import React from 'react';
import Header from './../../Header';
import Footer from './../../Footer';
import Menu from './../../Menu';
import Loader from './../../Loader';
import JournalNav from './../JournalNav';
import JournalList from './../List/JournalList';
import { fetchMenu } from "./../../../actions/menuActionCreators";
import { fetchJournals } from "./../../../actions/journalActionCreators";
import { fetchOptions } from "./../../../actions/optionActionCreators";
import ScrollNav from './../../ScrollNav';
import { Helmet } from 'react-helmet';
import ReactHtmlParser from 'react-html-parser';
import {
    NavLink,
    Link
} from 'react-router-dom'
import ReactGA from 'react-ga';
class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true
        }
    }
    componentDidMount() {
        let {category} = this.props.match.params;
        ReactGA.pageview('/journals/'+category);
        Promise.all([
            this.props.dispatch(fetchMenu('menu')),
            this.props.dispatch(fetchJournals()),
            this.props.dispatch(fetchOptions()),
        ]).then(() => {
            this.setState({
                pageLoading: false
            })
        });
    }

    render() {
        let {category} = this.props.match.params;
		let { menu } = this.props.menu;

        return (
			<div className="fullW">
                <Helmet>
                    <title>Lelay Architects | Journals</title>
                </Helmet>
                <Header {...this.props} />
                    <main className="ll__journal">
                        {this.state.pageLoading &&
                            <Loader />
                        }
                        <section>
                            <div className="main-container">
                                <JournalNav {...this.props} />
                                <JournalList {...this.props} category={category} />
                            </div>
                        </section>
                    </main>
                {menu.primary &&
                    <Menu {...this.props} />
                }
                <Footer {...this.props} />
                <ScrollNav/>
            </div>
        );
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Journals/Category/index.js